<template>
  <div
    class="aside aside-left aside-fixed d-flex flex-column flex-row-auto"
    id="kt_aside"
    :style="['admin','owner','staff'].includes(this.$store.state.role) ? sideBgColor : 'background-color:#F2F3F8'"
  >
    <div  v-if="['admin','owner','staff'].includes(this.$store.state.role)" class="brand flex-column-auto custom-color" :style="topbarColor" id="kt_brand" style="border-right:0.1px solid #f0f0f0">
      <div v-if="this.$store.getters.brand['customizeBrandNameSetting'] == 1">
        <div v-html="brand_name" class="text-center">

        </div>
      </div>
      <div v-else>
        <router-link tag="li" to="/dashboard" class="brand-logo" kt-hidden-height="65">
          <!-- <img :src="APIURL + brand_logo" width="200" height="60" alt="Brand Logo"> -->
          <img :src="getBrandImageUrl(brand_logo)" width="200" :style="{height:this.$store.state.brand.subdomain === 'nativemaps' ? '70px' : '60px'}" alt="Brand Logo">
        </router-link>
      </div>
      <button class="brand-toggle btn btn-sm px-0" aria-label="toggle" id="kt_aside_toggle">
        <span class="svg-icon svg-icon svg-icon-xl">
          <!--begin::Svg Icon | path:assets/media/svg/icons/Navigation/Angle-double-left.svg-->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
            width="24px"
            height="24px"
            viewBox="0 0 24 24"
            version="1.1"
          >
            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <polygon points="0 0 24 0 24 24 0 24" />
              <path
                d="M5.29288961,6.70710318 C4.90236532,6.31657888 4.90236532,5.68341391 5.29288961,5.29288961 C5.68341391,4.90236532 6.31657888,4.90236532 6.70710318,5.29288961 L12.7071032,11.2928896 C13.0856821,11.6714686 13.0989277,12.281055 12.7371505,12.675721 L7.23715054,18.675721 C6.86395813,19.08284 6.23139076,19.1103429 5.82427177,18.7371505 C5.41715278,18.3639581 5.38964985,17.7313908 5.76284226,17.3242718 L10.6158586,12.0300721 L5.29288961,6.70710318 Z"
                fill="#000000"
                fill-rule="nonzero"
                transform="translate(8.999997, 11.999999) scale(-1, 1) translate(-8.999997, -11.999999) "
              />
              <path
                d="M10.7071009,15.7071068 C10.3165766,16.0976311 9.68341162,16.0976311 9.29288733,15.7071068 C8.90236304,15.3165825 8.90236304,14.6834175 9.29288733,14.2928932 L15.2928873,8.29289322 C15.6714663,7.91431428 16.2810527,7.90106866 16.6757187,8.26284586 L22.6757187,13.7628459 C23.0828377,14.1360383 23.1103407,14.7686056 22.7371482,15.1757246 C22.3639558,15.5828436 21.7313885,15.6103465 21.3242695,15.2371541 L16.0300699,10.3841378 L10.7071009,15.7071068 Z"
                fill="#000000"
                fill-rule="nonzero"
                opacity="0.3"
                transform="translate(15.999997, 11.999999) scale(-1, 1) rotate(-270.000000) translate(-15.999997, -11.999999) "
              />
            </g>
          </svg>
          <!--end::Svg Icon-->
        </span>
      </button>
    </div>
    <div
      class="aside-menu-wrapper flex-column-fluid"
      id="kt_aside_menu_wrapper"
    >
      <div
        id="kt_aside_menu"
        class="aside-menu my-4 scroll ps ps--active-y settings-dropdown"
        data-menu-vertical="1"
        data-menu-scroll="1"
        data-menu-dropdown-timeout="500"
        :style="sideBgColor"
      >
        <ul class="menu-nav" :style="sideBgColor"  v-if="['admin','owner','staff'].includes(this.$store.state.role)">
          <router-link tag="li" id="dashboard_profile_tab" class="menu-item" to="/dashboard" exact-active-class="menu-item-active">
            <a class="menu-link">
              <i class="fas fa-layer-group menu-icon"></i>
              <span class="menu-text">{{$t('dashboard')}}</span>
            </a>
          </router-link>
          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-toggle="hover"
            id="orders_dropdown"
            name="orders_dropdown"
          >
            <a href="javascript:;" v-if="['admin', 'owner','staff'].includes(this.$store.getters.role) && this.$store.getters.permissions.includes('manage_order')" class="menu-link menu-toggle">

              <span class="menu-icon">
                <i class="fas fa-server menu-icon"></i>
              </span>
              <span class="menu-text">{{$t('orders')}}</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="menu-submenu">
              <i class="menu-arrow"></i>
              <ul class="menu-subnav">
                <li class="menu-item menu-item-parent" aria-haspopup="true">
                  <span class="menu-link">
                    <span class="menu-text">{{$t('orders')}}</span>
                  </span>
                </li>
                <router-link
                  id="orders_list_cta"
                  tag="li"                 
                  class="menu-item menu-item-submenu"
                  aria-haspopup="true"
                  to="/dashboard/orders"
                  exact
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link menu-toggle">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">{{$t('orders_list')}}</span>
                  </a>
                </router-link>
                <router-link
                  id="add_new_order_sidebar" name="add_new_order_sidebar"
                  tag="li"
                  class="menu-item menu-item-submenu"
                  to="/dashboard/orders/create"                 
                  aria-haspopup="true"
                  exact
                  exact-active-class="menu-item-active"
                  v-if="['admin', 'owner'].includes(this.$store.getters.role) ||this.$store.getters.permissions.includes('create_order')"
                >
                   <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">{{$t('add_new_order')}}</span>
                  </a>
                </router-link>
                <router-link
                  id="purchase_orders"
                  tag="li"                 
                  class="menu-item menu-item-submenu"
                  aria-haspopup="true"
                  to="/dashboard/orders/purchase-orders"
                  exact-active-class="menu-item-active"
                  v-if="['admin', 'owner'].includes(this.$store.getters.role) ||  this.$store.getters.permissions.includes('purchase_order')"
                >
                  <a class="menu-link menu-toggle">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" name="purchase_orders" >{{$t('purchase_orders')}}</span>
                  </a>
                </router-link>
                <router-link
                  id="export_orders" name="export_orders"
                  tag="li"                  
                  class="menu-item menu-item-submenu"
                  aria-haspopup="true"
                  to="/dashboard/orders/export"
                  exact-active-class="menu-item-active"
                >
                  <a v-if="['admin', 'owner'].includes(this.$store.getters.role) || this.$store.getters.permissions.includes('export_order')" class="menu-link menu-toggle">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">{{$t('export_orders')}}</span>
                  </a>
                </router-link>
                
              </ul>
            </div>
          </li>
          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"
            v-if="
              ['admin', 'owner'].includes(this.$store.getters.role) ||
              this.$store.getters.permissions.includes('manage_customer')
            "
          >
            <a href="javascript:;" class="menu-link menu-toggle">
              <span class="menu-icon">
                <i class="menu-icon flaticon-users-1"></i>
              </span>
              <span class="menu-text" id="customers_dropdown" name="customers_dropdown">{{$t('customers')}}</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="menu-submenu">
              <span class="menu-arrow"></span>
              <ul class="menu-subnav">
                <li class="menu-item menu-item-parent" aria-haspopup="true">
                  <span class="menu-link">
                    <span class="menu-text">{{$t('customers')}}</span>
                  </span>
                </li>
                <router-link
                  tag="li"                 
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/customers"
                  exact
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="customers_list" name="customers_list">{{$t('customers_list')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                  
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/customers/create"
                  exact
                  exact-active-class="menu-item-active"
                  v-if="
                    ['admin', 'owner'].includes(this.$store.getters.role) ||
                    this.$store.getters.permissions.includes('create_customer')
                  "
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="add_new_customers" name="add_new_customers">{{$t('add_new_customer')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/customers/import-export"
                  exact-active-class="menu-item-active"
                  v-if="['admin', 'owner'].includes(this.$store.getters.role) || this.$store.getters.permissions.includes('import_export_customer')"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">{{$t('import_export')}}</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>
          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"
            v-if="
              ['admin', 'owner'].includes(this.$store.getters.role) ||
              this.$store.getters.permissions.includes('manage_product')
            "
          >
            <a href="javascript:;" class="menu-link menu-toggle">
              <span class="menu-icon">
                <i class="menu-icon fas fa-cubes"></i>
              </span>
              <span class="menu-text" id="products_sidebar_option" name="products_sidebar_option">{{$t('products')}}</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="menu-submenu">
              <span class="menu-arrow"></span>
              <ul class="menu-subnav">
                <li class="menu-item menu-item-parent" aria-haspopup="true">
                  <span class="menu-link">
                    <span class="menu-link">{{$t('products')}}</span>
                  </span>
                </li>
                <router-link
                  tag="li"            
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/products"
                  exact
                  exact-active-class="menu-item-active"
                  v-if="
                    ['admin', 'owner'].includes(this.$store.getters.role) ||
                    this.$store.getters.permissions.includes('manage_product')
                  "
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">{{$t('products_list')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                 
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/products/create"
                  exact
                  exact-active-class="menu-item-active"
                  v-if="
                    ['admin', 'owner'].includes(this.$store.getters.role) ||
                    this.$store.getters.permissions.includes('create_product')
                  "
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">{{$t('add_new_product')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                  
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/product-collections"
                  exact-active-class="menu-item-active"
                  v-if="
                    ['admin', 'owner'].includes(this.$store.getters.role)
                  "
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="product_collections" name="product_collections">{{$t('product_collections')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/products-sorting"
                  exact-active-class="menu-item-active"
                   v-if="
                    ['admin', 'owner'].includes(this.$store.getters.role)
                  "
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="product_sorting_cta" name="product_sorting_cta">{{$t('Products Sorting')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/products/import-export"
                  exact-active-class="menu-item-active"
                  v-if="
                    ['admin', 'owner'].includes(this.$store.getters.role) ||
                    this.$store.getters.permissions.includes('importexport_product')
                  "
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">{{$t('import_export')}}</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>
          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"
            v-if="['admin', 'owner'].includes(this.$store.getters.role)"
          >
            <a href="javascript:;" class="menu-link menu-toggle">
              <span class="menu-icon">
                <i class="menu-icon fa fa-users"></i>
              </span>
              <span class="menu-text" id="staff_option_dropdown" name="staff_option_dropdown">{{$t('staff')}}</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="menu-submenu">
              <span class="menu-arrow"></span>
              <ul class="menu-subnav">
                <li class="menu-item menu-item-parent" aria-haspopup="true">
                  <span class="menu-link">
                    <span class="menu-text">{{$t('staff')}}</span>
                  </span>
                </li>
                <router-link
                  tag="li"                  
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/staff"
                  exact
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="staff_list_option" name="staff_list_option">{{$t('staff_list')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                 
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/staff/create"
                  exact
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">{{$t('add_staff')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                 
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/staff/commission-list"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="commission_cta" name="commission_cta">{{$t('commissions')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/staff/roles"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="permissions_cta" name="permissions_cta">{{$t('permissions')}}</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>
                    <!--********************** Categories ***********************************************-->
          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"
            v-if="
              ['admin', 'owner'].includes(this.$store.getters.role) ||
              this.$store.getters.permissions.includes('manage_category')
            "
          >
            <a href="javascript:;" class="menu-link menu-toggle">
              <span class="menu-icon">
                <i class="menu-icon fas fa-folder-open"></i>
              </span>
              <span class="menu-text" id="categories_dropdown" name="categories_dropdown">{{$t('categories')}}</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="menu-submenu">
              <span class="menu-arrow"></span>
              <ul class="menu-subnav">
                <li class="menu-item menu-item-parent" aria-haspopup="true">
                  <span class="menu-link">
                    <span class="menu-text">{{$t('categories')}}</span>
                  </span>
                </li>
                 <router-link
                  tag="li"                
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/categories"
                  exact-active-class="menu-item-active"
                  v-if="
                    ['admin', 'owner'].includes(this.$store.getters.role) ||
                    this.$store.getters.permissions.includes('manage_category')
                  "
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="category_list" name="category_list">{{$t('category_list')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                  
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/categories/create"
                  exact-active-class="menu-item-active"
                  v-if="
                    ['admin', 'owner'].includes(this.$store.getters.role) ||
                    this.$store.getters.permissions.includes('manage_category')
                  "
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="add_new_category" name="add_new_category">{{$t('add_category')}}</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>
          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"
            v-if="['admin', 'owner', 'staff'].includes(this.$store.getters.role) && this.$store.getters.permissions.includes('show_documents') && this.$store.getters.brand['subdomain'] != 'qrjoy'"
          >
            <router-link
              tag="li"
              to="/dashboard/documents"
              class="menu-link menu-toggle"
            >
              <span class="menu-icon">
                <i class="menu-icon fas fa-barcode"></i>
              </span>
              <span class="menu-text">{{$t('documents')}}</span>
            </router-link>
            <div class="menu-submenu">
              <ul class="menu-subnav">
                <li
                  class="menu-item menu-item-parent"
                  href="#kt_tabs_files"
                  aria-haspopup="true"
                >
                  <span class="menu-link">
                    <span class="menu-text">{{$t('documents')}}</span>
                  </span>
                </li>
              </ul>
            </div>
          </li>
          <!--********************** Reports ***************************************************-->
          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"
            v-if="['admin', 'owner', 'staff'].includes(this.$store.getters.role) && this.$store.getters.permissions.includes('show_reports')"
          >
            <router-link
              tag="li"
              to="/dashboard/reports"
              class="menu-link menu-toggle"
            >
              <span class="menu-icon">
                <i class="menu-icon fas fa-chart-bar"></i>
              </span>
              <span class="menu-text" id="reports_option" name="reports_option">{{$t('reports')}}</span>
            </router-link>
          </li>
          <!--.............................End Report........................................-->

          <!--********************** Warehuse Permission for Staff ***************************************************-->
          <!-- <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"
            v-if="['staff'].includes(this.$store.getters.role) && this.$store.getters.permissions.includes('manage_warehouse')"
          >
            <router-link
            tag="li"
            to="/dashboard/multi-warehouse"
              class="menu-link menu-toggle"
            >
              <span class="menu-icon">
                <i class="fa-solid fa-warehouse"></i>
              </span>
              <span class="menu-text">{{$t('Warehouse')}}</span>
            </router-link>
          </li> -->
          <!--.............................Warehuse Permission for Staff........................................-->
          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"
            v-if="['admin', 'owner'].includes(this.$store.getters.role)"
          >
            <a href="javascript:;" class="menu-link menu-toggle">
              <span class="svg-icon menu-icon">
                <i class="fas fa-tools menu-icon"></i>
              </span>
              <span class="menu-text" id="settings_dropdown" name="settings_dropdown">{{ $t('settings') }}</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="menu-submenu">
              <span class="menu-arrow"></span>
              <ul class="menu-subnav">
                <li class="menu-item menu-item-parent" aria-haspopup="true">
                  <span class="menu-link">
                    <span class="menu-text">{{ $t('settings') }}</span>
                  </span>
                </li>
                <router-link
                  tag="li"                 
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/settings/brand_info"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="brand_settings" name="brand_settings">{{ $t('Brand Settings') }}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                 
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/settings/store"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="store_settings" name="store_settings">{{ $t('store_settings') }}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                  
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/settings/subscription"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">{{ $t('subscription') }}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                 
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/price-tiers"
                  exact-active-class="menu-item-active"
                  v-if="
                    ['admin', 'owner'].includes(this.$store.getters.role) ||
                    this.$store.getters.permissions.includes('price_tiers')
                  "
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="price_tiers" name="price_tiers">{{ $t('price_tiers') }}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                  
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/volume-price-tiers"
                  exact-active-class="menu-item-active"
                  v-if="
                    ['admin', 'owner'].includes(this.$store.getters.role) ||
                    this.$store.getters.permissions.includes('price_tiers')
                  "
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="volume_priceTiers" name="volume_priceTiers">{{ $t('volume_price_tiers') }}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                 
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/multi-warehouse"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="warehouse_option" name="warehouse_option">{{ $t('Warehouse') }}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                  
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/settings/brand-promo-codes"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="promo_codes_option" name="promo_codes_option">{{ $t('promo_codes') }}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                  
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/settings/shipment_methods_settings"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="shipping_methods_option" name="shipping_methods_option">{{ $t('shipping_methods') }}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                 
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/settings/signup-form"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="signup-form-option" name="signup-form-option">{{$t('signup_form')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                 
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/settings/custom-layout"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="custom_layout_option" name="custom_layout_option">{{ $t('custom_layout') }}</span>
                  </a>
                </router-link>
                <template v-if="$store.state.brand_settings['enable_product_meta_fields'] == '1'">
                  <router-link
                  tag="li"                   
                    class="menu-item"
                    aria-haspopup="true"
                    to="/dashboard/settings/product-meta-fields"
                    exact-active-class="menu-item-active"
                  >
                    <a class="menu-link">
                      <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                      <span class="menu-text">{{$t('Product Meta Fields')}}</span>
                    </a>
                  </router-link>
                </template>
                <router-link
                  tag="li"                 
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/settings/vendors"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="vendors_option" name="vendors_option">{{$t('vendors')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                 
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/settings/currency"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="currency_option" name="currency_option">{{$t('currency')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                 
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/settings/api-settings"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text" id="api_settings" name="api_settings">{{ $t('API Settings') }}</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>

          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"
            v-if="['admin', 'owner'].includes(this.$store.getters.role) 
            && !this.$store.getters.brand['isShopifyUser']"
          >
            <router-link
              tag="li"
              to="/dashboard/settings/payments"
              class="menu-link menu-toggle"
            >
              <span class="menu-icon">
                <i class="fa fa-credit-card"></i>
              </span>
              <span class="menu-text">{{$t('payments')}}</span>
            </router-link>
          </li>
          
          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"
            v-if="['admin', 'owner'].includes(this.$store.getters.role)"
          >
                <router-link
                  tag="li"
                  class="menu-link menu-toggle"
                  to="/dashboard/integrations"
                >
                  <a class="menu-icon">
                    <i class="fas fa-cogs menu-icon"> <span></span></i>
                    <span class="menu-text">{{$t('integrations')}}</span>
                  </a>
                </router-link>
          </li>
          <!-- QuickBooks Menu Drop Down -->
          <li v-if="['admin', 'owner'].includes(this.$store.getters.role)
             &&  this.$store.state.integrations?.includes('quickbooks')"
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"

          >
            <a href="javascript:;" class="menu-link menu-toggle">
              <span class="menu-icon">
                <i class="fas fa-book menu-icon"></i>
              </span>
              <span class="menu-text">{{$t('quickBooks')}}</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="menu-submenu">
              <span class="menu-arrow"></span>
              <ul class="menu-subnav">
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/quickbooks/sync-orders"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text"> {{$t('sync_orders')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/quickbooks/link-products"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">{{$t('link products')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/quickbooks/link-customers"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">{{$t('link customers')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                 
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/quickbooks/sync-customers"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">{{$t('sync_quickbooks_customers')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                 
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/quickbooks/sync-products"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">{{$t('sync_quickbooks_products')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"                 
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/quickbooks/misc-settings"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text"> {{$t('misc_settings')}}</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>
          <!-- Ship Station Menu Drop Down -->
          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"
            v-if="['admin', 'owner'].includes(this.$store.getters.role)
            && this.$store.state.integrations?.includes('shipstation')"
          >
            <a href="javascript:;" class="menu-link menu-toggle">
              <span class="menu-icon">
                <i class="fas fa-truck menu-icon"></i>
              </span>
              <span class="menu-text"> {{$t('ship_station')}}</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="menu-submenu">
              <span class="menu-arrow"></span>
              <ul class="menu-subnav">
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/shipstation/sync-orders"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">{{$t('sync_orders')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/shipstation/sync-products"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">Sync Products</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/shipstation/misc-settings"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text"> {{$t('misc_settings')}}</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>
          <!-- Shopify Menu Drop Down -->
          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover" v-if="['admin', 'owner'].includes(this.$store.getters.role)
            && this.$store.state.integrations?.includes('shopify')"
            >
            <a href="javascript:;" class="menu-link menu-toggle">
              <span class="menu-icon">
                <i class="fas fa-shopping-cart menu-icon"></i>
              </span>
              <span class="menu-text">{{$t('shopify')}}</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="menu-submenu">
              <span class="menu-arrow"></span>
              <ul class="menu-subnav">
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/shopify/sync-products"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">Sync Products</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/shopify/misc-settings"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text"> {{$t('misc_settings')}}</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>
          <!-- Xero Menu Drop Down -->
          <li v-if="['admin', 'owner'].includes(this.$store.getters.role) && this.$store.state.integrations?.includes('xero')"
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"

          >
            <a href="javascript:;" class="menu-link menu-toggle">
              <span class="menu-icon">
                <i class="fas fa-book menu-icon"></i>
              </span>
              <span class="menu-text">{{$t('xero')}}</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="menu-submenu">
              <span class="menu-arrow"></span>
              <ul class="menu-subnav">
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/xero/sync-orders"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">{{$t('sync_orders')}}</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/xero/link-products"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">Link Products</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/xero/link-customers"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">Link Customers</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/xero/misc-settings"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text"> {{$t('misc_settings')}}</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>
          <!-- Woocommerce Menu Drop Down -->
          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover" v-if="['admin', 'owner'].includes(this.$store.getters.role) && this.$store.state.integrations?.includes('woocommerce')"
            >
            <a href="javascript:;" class="menu-link menu-toggle">
              <span class="menu-icon">
                <i class="fas fa-shopping-cart menu-icon"></i>
              </span>
              <span class="menu-text">WooCommerce</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="menu-submenu">
              <span class="menu-arrow"></span>
              <ul class="menu-subnav">
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/woocommerce/sync-orders"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">Sync Orders</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/woocommerce/link-products"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">Link Products</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/woocommerce/link-customers"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">Link Customers</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/woocommerce/sync-customers"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">Sync Customers</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/woocommerce/sync-products"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">Sync Products</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/woocommerce/misc-settings"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text"> {{$t('misc_settings')}}</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>
          <!-- HubSpot Menu Drop Down -->
          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"
            v-if="['admin', 'owner'].includes(this.$store.getters.role)
            && this.$store.state.integrations?.includes('hubspot')
            "
          >
            <a href="javascript:;" class="menu-link menu-toggle">
              <span class="menu-icon">
                <i class="fab fa-hubspot menu-icon"></i>
              </span>
              <span class="menu-text"> HubSpot </span>
              <i class="menu-arrow"></i>
            </a>
            <div class="menu-submenu">
              <span class="menu-arrow"></span>
              <ul class="menu-subnav">
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/hubspot/sync-customers"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">Sync Customers</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/hubspot/link-customers"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">Link Customers</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>
          <!-- HubSpot Menu Drop Down -->
           <!-- AI Assistant Menu Item -->
          <li
            v-if="['admin','owner','staff'].includes(this.$store.state.role)"
            class="menu-item"
            aria-haspopup="true"
          >
            <a @click="openAIAssistant()" class="menu-link">
              <span class="menu-icon">
                <i class="menu-icon fas fa-robot"></i>
              </span>
              <span class="menu-text">AI Assistant <span class="badge badge-primary badge-pill ml-2">New</span></span>
            </a>
          </li>
          <!-- Odoo Menu Drop Down -->
          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover" v-if="['admin', 'owner'].includes(this.$store.getters.role)
            && this.$store.state.integrations?.includes('odoo')"
            >
            <a href="javascript:;" class="menu-link menu-toggle">
              <span class="menu-icon">
                <i class="fa fa-sync-alt menu-icon"></i>
              </span>
              <span class="menu-text">{{$t('Odoo')}}</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="menu-submenu">
              <span class="menu-arrow"></span>
              <ul class="menu-subnav">
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/odoo/sync-orders"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">Sync Orders</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/odoo/link-products"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">Link Products</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/odoo/link-customers"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">Link Customers</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/odoo/sync-customers"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">Sync Odoo Customers</span>
                  </a>
                </router-link>
                <router-link
                  tag="li"
                  class="menu-item"
                  aria-haspopup="true"
                  to="/dashboard/odoo/sync-products"
                  exact-active-class="menu-item-active"
                >
                  <a class="menu-link">
                    <i class="menu-bullet menu-bullet-dot"> <span></span></i>
                    <span class="menu-text">Sync Odoo Products</span>
                  </a>
                </router-link>
              </ul>
            </div>
          </li>
          <!-- Odoo Menu Drop Down -->
          <!-- Cin7 Menu Drop Down -->
          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"
            v-if="['admin', 'owner'].includes(this.$store.getters.role)
            && this.$store.state.integrations?.includes('cin7')"
          >
            <a href="javascript:;" class="menu-link menu-toggle">
              <span class="menu-icon">
                <i class="fa fa-sync-alt menu-icon"></i>
              </span>
              <span class="menu-text">Cin7</span>
              <i class="menu-arrow"></i>
            </a>
            <div class="menu-submenu">
              <span class="menu-arrow"></span>
              <ul class="menu-subnav">
                <!-- May used in future for Cin7 integration, currently not in use. -->
                <!-- <router-link tag="li" class="menu-item" aria-haspopup="true" to="/dashboard/cin7/sync-orders" exact-active-class="menu-item-active">
                  <a class="menu-link"><i class="menu-bullet menu-bullet-dot"><span></span></i><span class="menu-text">Sync Orders</span></a>
                </router-link>
                <router-link tag="li" class="menu-item" aria-haspopup="true" to="/dashboard/cin7/link-products" exact-active-class="menu-item-active">
                  <a class="menu-link"><i class="menu-bullet menu-bullet-dot"><span></span></i><span class="menu-text">Link Products</span></a>
                </router-link>
                <router-link tag="li" class="menu-item" aria-haspopup="true" to="/dashboard/cin7/link-customers" exact-active-class="menu-item-active">
                  <a class="menu-link"><i class="menu-bullet menu-bullet-dot"><span></span></i><span class="menu-text">Link Customers</span></a>
                </router-link> -->
                <router-link tag="li" class="menu-item" aria-haspopup="true" to="/dashboard/cin7/sync-customers" exact-active-class="menu-item-active">
                  <a class="menu-link"><i class="menu-bullet menu-bullet-dot"><span></span></i><span class="menu-text">Sync Cin7 Customers</span></a>
                </router-link>
                <router-link tag="li" class="menu-item" aria-haspopup="true" to="/dashboard/cin7/sync-products" exact-active-class="menu-item-active">
                  <a class="menu-link"><i class="menu-bullet menu-bullet-dot"><span></span></i><span class="menu-text">Sync Cin7 Products</span></a>
                </router-link>
                <router-link tag="li" class="menu-item" aria-haspopup="true" to="/dashboard/cin7/misc-settings" exact-active-class="menu-item-active">
                  <a class="menu-link"><i class="menu-bullet menu-bullet-dot"><span></span></i><span class="menu-text">Misc Settings</span></a>
                </router-link>
              </ul>
            </div>
          </li>
          <!-- Cin7 Menu Drop Down -->
          <li
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"
            v-if="
              (['customer', 'customer-contact'].includes(
                this.$store.getters.role
              ) || this.$store.getters.permissions.includes('show_customer_preview')) && this.$store.getters.brand['subdomain'] != 'qrjoy'"
          >
            <a @click="impersonate()" class="menu-link">
              <span class="menu-icon">
                <i class="menu-icon fa fa-eye"></i>
              </span>
              <span class="menu-text">{{$t('preview_customer_shop')}} </span>
            </a>
          </li>
          <li
            v-if="this.$store.getters.brand['subdomain'] != 'qrjoy' && !['staff'].includes(this.$store.getters.role)"
            class="menu-item menu-item-submenu"
            aria-haspopup="true"
            data-menu-submenu-toggle="hover"
          >
            <router-link
              tag="li"
              to="/dashboard/changeLogs"
              class="menu-link menu-toggle"
            >
                <span class="menu-icon">
                    <i class="menu-icon fas fa-clock"></i>
                </span>
                <span class="menu-text">
                    {{$t('oc_updates')}} {{ year }}
                </span>
            </router-link>
            <div class="menu-submenu">
              <ul class="menu-subnav">
                <li
                  class="menu-item menu-item-parent"
                  href="#kt_tabs_files"
                  aria-haspopup="true"
                >
                  <span class="menu-link">
                    <span class="menu-text">
                        {{$t('oc_updates')}} {{ year }}
                    </span>
                  </span>
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <div class="ps__rail-x" style="left: 0px; bottom: 0px">
          <div
            class="ps__thumb-x"
            tabindex="0"
            style="left: 0px; width: 0px"
          ></div>
        </div>
        <div class="ps__rail-y" style="top: 0px; height: 310px; right: 4px">
          <div
            class="ps__thumb-y"
            tabindex="0"
            style="top: 0px; height: 140px"
          ></div>
        </div>
      </div>
    </div>
    <!-- AI Assistant Widget -->
    <ChatbotWidget 
      v-if="showAIAssistant" 
      ref="chatbotWidget"
      :initial-open="true"
      :default-dark-mode="false"
    />
  </div>
</template>
<script>
import LoginAPIService from '@/js/api/auth/auth';
import ChatbotWidget from '@/js/ordercircle/brands/dashboard/chatbot/ChatbotWidget.vue';
import { nextTick } from 'vue';
import { Import } from 'lucide-vue-next';
import { getBrandImageUrl } from '@/js/utils/common.js';

export default {
  name: "sidebar",
  components: {
    ChatbotWidget
  },
  mounted:function () {
    nextTick(() => {
      this.setNavigation(); // Ensure that the DOM is fully rendered before running this method
    });
    	// $('ul.menu-nav a, ul.menu-subnav li, ul.menu-subnav a').on('click',function (){
      // 		$(this).removeClass('menu-item-active');
      // 		$(this).addClass('menu-item-active');
    	// });
        this.brand_name = this.$store.state.brand['customizeBrandName'];
        this.brand_logo = this.$store.state.brand['brand_logo'];
        if(this.brand_logo != null &&  this.brand_logo != undefined &&  this.brand_logo != ""){
            this.brand_logo = '/uploads/brand_logos/'+ this.brand_logo;
        }else {
            this.brand_logo = '/images/brand_logos/dummy_company_logo.jpg';
        }
	},
	data(){
        return{
      		brand_name: null,
      		brand_logo: null,
          currentactiveState:'',
          year: new Date().getFullYear(),
      		searchQuery: '',
          color: '#341ba1',
          access_token : localStorage.getItem("access_token"),
          showAIAssistant: false,
          APIURL: import.meta.env.VITE_API_URL,
    	}
    },
    computed:{
        sideBgColor(){
            return {

                'background-color': this.$store.state.brand_skins['sidebar_bg_color'],
            };
        },
        topbarColor(){
            return {
                'background-color': this.$store.state.brand_skins['topbar_bg_color'],
            };
        }
    },
    methods:{
      getBrandImageUrl,
      setNavigation(){
         var path = window.location.pathname;
         var state='';
          $(".menu-nav a").each(function () {
              var href = $(this).attr('href');
              if (path === href) {
                state=$(this).parents('li').last();
                 state.addClass('menu-item-open');
              }
          });
          this.currentactiveState=state
      },
      impersonate(){
        this.$store.commit('SHOW_LOADER',true);
        localStorage.setItem('impersonated', 'true');
        LoginAPIService.impersonateToCustomer(this.access_token).then((response) => {
          this.$store.dispatch('getData',response.data)
          // this.$router.push("/shop");
          window.location.href='/shop'
          // this.$store.commit('SHOW_LOADER',false);
        }).catch((error) => {
          this.$store.commit('SHOW_LOADER',false);

          this.notify("Error!", "Error", "error");
        })
      },
        openAIAssistant() {
          this.showAIAssistant = true;
          
          // Add a small delay to ensure the component is fully rendered
          setTimeout(() => {
            if (this.$refs.chatbotWidget) {
              this.$refs.chatbotWidget.openChat();
            }
          }, 100);
        }
    },
    watch:{
    $route (to, from){
      if(this.currentactiveState){
        this.currentactiveState.removeClass('menu-item-open')
      }
      nextTick(() => {
        this.setNavigation(); // Ensure the navigation is updated after the route change
      });
    }
}

};
</script>
<style scoped>
@media (max-width: 767px) {
  .settings-dropdown {
    overflow-y: auto !important; /* Enable vertical scrolling if the content exceeds the maximum height */
  }
}
.menu-nav .menu-item .menu-text {
  color: #ebebeb !important;
}
.menu-nav .menu-item .menu-icon {
  color: #ebebeb !important;
}
.menu-nav.menu-item:hover {
  color: #479fd7;
}
.brand-logo {
  color: #ffffff;
}
.brand-header {
  background-color: #ffffff;
}
.router-link-active .menu-bullet-dot span {
  background-color: #479fd7  !important ;
}
li.menu-item.kt-menu__item--active.router-link-active {
  background-color: #479fd7  !important ;
}
.aside .aside-menu {
    background-color: #1e1e2d;
}
</style>

